import {addTagsModalStyles} from"@insite/content-library/Widgets/MyListsDetails/AddTagsModal";
import { css } from "styled-components";


addTagsModalStyles.cancelButton={
    color: "secondary",
        css: css`
            margin-right: 10px;
            border-radius: 24px;
            min-height: 32px;
        `,
}